module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/1-4dc4274200a7430f989d0323ce5edf07.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/1.mp3
// module id = 63
// module chunks = 0